import { styled } from '@/shared/ui';
import { Alert } from '@/shared/ui/Alert';

export const StyledAlert = styled(Alert)(({ theme }) => ({
  color: theme.palette.primary.main,
}));
